import React from 'react';
import styled from 'styled-components';

export interface SectionHeaderProps {
  /** 标题 */
  title: string;
  /** 描述 */
  description?: string;
  /** 容器样式 */
  style?: React.CSSProperties;
  /** title 样式 */
  titleStyle?: React.CSSProperties;
  /** 自定义操作 */
  actions?: React.ReactNode;
  /** 用于行内不要 margin */
  inline?: boolean;
}

/**
 * SectionHeader 区块标题
 * 用于展示页面中每个 section 的标题和描述，并提供操作区域。
 */
export function SectionHeader({
  title,
  description,
  style,
  titleStyle,
  actions,
  inline,
}: SectionHeaderProps) {
  return (
    <Box style={style} $inline={inline}>
      <Header>
        <Title style={titleStyle}>{title}</Title>
        {description && <Content>{description}</Content>}
      </Header>
      <ActionsArea>
        {/* 这里可以放置一些操作按钮 */}
        {actions}
      </ActionsArea>
    </Box>
  );
}

/** ============================ 样式 ==================================== */
const Box = styled.div<{ $inline?: boolean }>`
  color: #000;
  margin-bottom: ${({ $inline }) => ($inline ? '0' : '16px')};
  display: flex;
  justify-content: space-between;
`;
const Header = styled.div``;
const ActionsArea = styled.div``;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
`;
const Content = styled.div`
  opacity: 0.45;
  font-size: 12px;
`;
